module.exports = __webpack_public_path__ + "img/logo.adb4d122.png";